import { render, staticRenderFns } from "./SectionObservations.vue?vue&type=template&id=8e506760&"
import script from "./SectionObservations.vue?vue&type=script&lang=js&"
export * from "./SectionObservations.vue?vue&type=script&lang=js&"
import style0 from "./SectionObservations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports